import { ReactNode } from "react";

export interface ReportFooterProps {
  children: ReactNode;
}

export function ReportFooter({ children }: ReportFooterProps) {
  return (
    <div className="bg-white border rounded-xl py-3 px-4 mt-4">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        {children}
      </div>
    </div>
  );
}
